import {
	ProductSubDepartmentAutocompleteDocument,
	type ProductSubDepartmentAutocompleteQuery,
	type ProductSubDepartmentAutocompleteQueryVariables,
} from "@/generated/graphql";
import type { AutocompleteFetchResult } from "@k3-tech/react-kit";
import { useCallback } from "react";
import { useClient } from "urql";

export const useProductSubDepartmentAutocomplete = () => {
	const urqlClient = useClient();

	const load = useCallback(
		async (page: number, pageSize: number, search: string) => {
			const { data } = await urqlClient
				.query<
					ProductSubDepartmentAutocompleteQuery,
					ProductSubDepartmentAutocompleteQueryVariables
				>(
					ProductSubDepartmentAutocompleteDocument,
					{
						qop: {
							pagination: {
								page: page,
								pageSize: pageSize,
								withCount: true,
							},
							filters: {
								productSubDepartmentName: search,
							},
						},
					},
					{
						suspense: false,
						requestPolicy: "network-only",
					},
				)
				.toPromise();

			const rawItems = data?.productSubDepartments?.items ?? [];
			const items = (rawItems || [])
				.filter((it): it is NonNullable<typeof it> => Boolean(it))
				.map((item) => ({
					value: item.productSubDepartmentID,
					label: item.productSubDepartmentName,
				}));

			return {
				items: items ?? [],
				total: data?.productSubDepartments?.pagination?.totalRows ?? 0,
				hasMore: data?.productSubDepartments?.pagination?.hasNext ?? false,
			} as AutocompleteFetchResult;
		},
		[urqlClient],
	);

	return {
		load,
	};
};
